/**
 * Giữ lại các lớp còn ít nhất 1 học viên đang được chọn.
 * Lớp không có dữ liệu học viên (chưa tải) được giữ nguyên để tránh mất lựa chọn ngoài ý muốn.
 */
export const pruneClassIdsBySelectedUsers = (
  classIds: (number | string)[],
  selectedUserIds: (number | string)[],
  studentsByClass: Record<string, { id: number | string }[]>
): (number | string)[] => {
  const selectedUserSet = new Set(selectedUserIds.map(String));

  return classIds.filter((classId) => {
    const students = studentsByClass[String(classId)];
    if (!students || students.length === 0) return true;

    return students.some((student) => selectedUserSet.has(String(student.id)));
  });
};
